import {
  Box,
  ButtonBase, Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DisplayFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import withSessionDetailsSectionErrorBoundary from '../SessionDetailsSectionErrorBoundary';
import DisplayOrigin from './DisplayOrigin';
import StyledBox from './styles';
import useDisplayCards from './useDisplayCards';

interface DisplayResumeProps {
  displays: DisplayFieldsFragment[];
}
function SummaryDisplay(props: DisplayResumeProps) {
  const { displays } = props;
  const { t } = useTranslation('session');
  const { t: tCommon } = useTranslation('common');
  const { cards, seeMore } = useDisplayCards(displays);

  if (!cards.length) return null;
  return (
    <StyledBox>
      <Typography variant="subtitle1">
        {t('details.content')}
      </Typography>
      <Box className="header">
        <Typography variant="subtitle2">
          {t('details.cards.title')}
        </Typography>
        <Typography variant="subtitle2">
          {t('details.display.title')}
        </Typography>
      </Box>
      <Box className="content">
        <Box className="cards">
          {cards?.map((card) => (
            <Box key={card.card.id}>
              <Typography title={card.card.title}>
                {card.card.title}
              </Typography>
              <DisplayOrigin displays={card.displays} total={card.count} />
            </Box>
          ))}
        </Box>
        {seeMore && (
          <ButtonBase color="primary" onClick={() => seeMore.toggle()} className="seeMore">
            {seeMore.displayAll ? tCommon('See Less') : tCommon('See More')}
          </ButtonBase>
        )}
      </Box>
    </StyledBox>
  );
}

export default withSessionDetailsSectionErrorBoundary(SummaryDisplay, 'summary display');
